export type BankAccountDropdownFilters = Record<string, string | boolean | number | undefined>;

export const bankAccountDropdownListBaseQueryKey = ['bankAccountDropdown', 'list'] as const;

export const bankAccountDropdownListQueryKey = (
  platformId?: string,
  isSandbox?: boolean,
  query?: BankAccountDropdownFilters
) => [...bankAccountDropdownListBaseQueryKey, platformId, isSandbox, query] as const;
